module.exports = __webpack_public_path__ + "static/media/cancel-disabled.d27d1337.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/cancel-disabled.svg
// module id = 359
// module chunks = 0